Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.components = void 0;
var _airtable = require("../airtable");
var _buzzsprout = require("../buzzsprout");
var _cinnamon = require("../cinnamon");
var _codepen = require("../codepen");
var _codesandbox = require("../codesandbox");
var _egghead = require("../egghead");
var _figma = require("../figma");
var _flickr = require("../flickr");
var _gist = require("../gist");
var _instagram = require("../instagram");
var _lbry = require("../lbry");
var _linkedin = require("../linkedin");
var _pinterest = require("../pinterest");
var _replit = require("../replit");
var _simplecast = require("../simplecast");
var _soundcloud = require("../soundcloud");
var _spotify = require("../spotify");
var _strava = require("../strava");
var _snack = require("../snack");
var _tiktok = require("../tiktok");
var _twitch = require("../twitch");
var _twitter = require("../twitter");
var _vimeo = require("../vimeo");
var _whimsical = require("../whimsical");
var _wikipedia = require("../wikipedia");
var _wistia = require("../wistia");
var _youtube = require("../youtube");
var components = {
  AirtableBase: _airtable.AirtableBase,
  AirtableForm: _airtable.AirtableForm,
  Buzzsprout: _buzzsprout.Buzzsprout,
  Cinnamon: _cinnamon.Cinnamon,
  CodePen: _codepen.CodePen,
  CodeSandbox: _codesandbox.CodeSandbox,
  EggheadLesson: _egghead.EggheadLesson,
  Figma: _figma.Figma,
  Flickr: _flickr.Flickr,
  Gist: _gist.Gist,
  Instagram: _instagram.Instagram,
  Lbry: _lbry.Lbry,
  LinkedInBadge: _linkedin.LinkedInBadge,
  Pin: _pinterest.Pin,
  PinterestBoard: _pinterest.PinterestBoard,
  PinterestFollowButton: _pinterest.PinterestFollowButton,
  Replit: _replit.Replit,
  SimplecastEpisode: _simplecast.SimplecastEpisode,
  SoundCloud: _soundcloud.SoundCloud,
  Spotify: _spotify.Spotify,
  Strava: _strava.Strava,
  Snack: _snack.Snack,
  TikTok: _tiktok.TikTok,
  Twitch: _twitch.Twitch,
  Tweet: _twitter.Tweet,
  TwitterFollowButton: _twitter.TwitterFollowButton,
  TwitterHashtagButton: _twitter.TwitterHashtagButton,
  TwitterList: _twitter.TwitterList,
  TwitterMentionButton: _twitter.TwitterMentionButton,
  TwitterTimeline: _twitter.TwitterTimeline,
  Vimeo: _vimeo.Vimeo,
  Whimsical: _whimsical.Whimsical,
  Wikipedia: _wikipedia.Wikipedia,
  Wistia: _wistia.Wistia,
  YouTube: _youtube.YouTube
};
exports.components = components;